import { CatalogTabsType } from "../../models/education/catalog-tabs-model"
import Pagination, { bootstrap5PaginationPreset, } from "react-responsive-pagination";

const CoursesTabContent = (props: { tabContent: CatalogTabsType[], isPagination: boolean, pageNumber: number, choosePageNumber: (page: number) => void }) => {
  const { tabContent, choosePageNumber, pageNumber, isPagination } = props;

  let totalResults = tabContent[0]?.totalNumberOfResults
  const totalPages = Math.ceil(totalResults / 8);

  //   Handle Page 
  const handlePageChange = (page: number) => {
    choosePageNumber(page)
  };

  return <>
    {
      tabContent[0]?.tabContent && <div className="intro" dangerouslySetInnerHTML={{ __html: tabContent[0]?.tabContent }}></div>
    }

    {
      (totalResults > 8 && isPagination) ? (
        <div className="col-md-12  sort-top">
          <div className="sort-status">
            <div className="sort-results">
              <label>Pages: <strong>{pageNumber}</strong> of <strong>{totalPages}</strong></label>
            </div>
            <div className="sort-paging">
              <Pagination
                className="pagination pagination-sm"
                {...bootstrap5PaginationPreset} // include Bootstrap 5 preset
                total={totalPages}
                current={pageNumber}
                onPageChange={(page: number) =>
                  handlePageChange(page)
                }
              />
            </div>
          </div>
        </div>
      ) : null
    }
    <div className="row">
      {
        props && tabContent[0]?.catalogList?.map((item, index) => {
          return <div className="col-md-3 text-center" key={index} style={{ marginTop: '15px', marginBottom: '15px' }}>
            <span className="category-type category-raps-product">
              <span className="category-text" dangerouslySetInnerHTML={{ __html: item.badgeUrl }}></span>
            </span>
            <div className="product-img">
              <a href={`/products/${item.nodeName}`}><img alt={item.name} src={item.imageUrl} loading="lazy" /></a>
            </div>

            <h5 className="title text-left" style={{ margin: '5px 0' }} ><a href={`/products/${item.nodeName}`}>{item.name}</a></h5>

            <div className="products text-left" style={{ display: 'none' }}>
              <span className="meta-item rac-credits">
                <span style={{ margin: '3px 0' }} className="rac-credits"><span style={{ marginRight: '6px' }} className="badge badge-credits"> 0.0  </span><span className="badge-label">RAC Credits</span>  </span>
              </span>
            </div>
            {item.shortDescription && <div className="description small text-left" dangerouslySetInnerHTML={{ __html: item.shortDescription }}></div>}
          </div>
        })
      }
    </div>
    {
      (totalResults > 8 && isPagination) ? (
        <div className="col-md-12">
          <div className="sort-status">
            <div className="sort-results">
              <label>Pages: <strong>{pageNumber}</strong> of <strong>{totalPages}</strong></label>
            </div>
            <div className="sort-paging">
              <Pagination
                className="pagination pagination-sm"
                {...bootstrap5PaginationPreset} // include Bootstrap 5 preset
                total={totalPages}
                current={pageNumber}
                onPageChange={(page: number) =>
                  handlePageChange(page)
                }
              />
            </div>
          </div>
        </div>
      ) : null
    }
  </>
}

export default CoursesTabContent;